import { Card as PolarisCard } from "@shopify/polaris";
import Card from "./Card";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
Card.Section = PolarisCard.Section;
export default Card;
